// extracted by mini-css-extract-plugin
export default {"PhotoSection":"PhotoSection_PhotoSection__kln+f"};